
import Vue from 'vue';
import ArrowLeftIcon from '../../Icons/ArrowLeftIcon.vue';
import QoalaTyped from '../../Icons/QoalaTyped.vue';
import WebText from '../Text/Text.vue';
import { Padder } from '../Spacings';
import { Row, Column } from '../Grid';
import Token from '../Token';

/**
 * The Header of the Application.
 *
 * This template consist of:
 *
 * - Back icon
 * - Logo / Title
 * - Right Component
 */
export default Vue.extend({
  name: 'AppBar',
  components: {
    ArrowLeftIcon,
    Padder,
    WebText,
    Row,
    QoalaTyped
  },
  props: {
    /**
     * The title of the navigation.
     * If omit empty, the title will be Qoala logo.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Color of the Title and Back Icon.
     */
    color: {
      type: String,
      default: null
    },
    /**
     * Make title bold.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Inverted version of navigation bar.
     */
    isWhite: {
      type: Boolean,
      default: false
    },
    /**
     * Template for the right of navigation bar
     * The type is VueComponent.
     */
    rightComponent: {
      type: Object,
      default: () => {}
    },
    /**
     * Hide the back icon.
     */
    hideNavigation: {
      type: Boolean,
      default: false
    },
    /**
     * Background color of the navigation bar.
     */
    backgroundColor: {
      type: String,
      default: null
    }
  },
  methods: {
    handleNavigateBack() {
      /**
       * Handle when user click the back icon.
       * @event back
       * @type {function}
       */
      this.$emit('back');
    },
    handleRightClick() {
      /**
       * Handle when user click the right component if available.
       * @event right
       * @type {function}
       */
      this.$emit('right');
    }
  },
  computed: {
    arrowBackColor() {
      if (this.color) {
        return `${this.color}`;
      } else {
        return this.isWhite ? Token.colors.uiBlueDarker : Token.colors.uiLightPrimary;
      }
    },
    titleColor() {
      if (this.color) {
        return `color:${this.color}`;
      } else {
        if (this.isWhite) {
          return `color:${Token.colors.uiOrangePrimary}`;
        } else {
          return `colorP:${Token.colors.uiLightPrimary}`;
        }
      }
    }
  }
});
